module.exports = __webpack_public_path__ + "static/media/check-icn.bc24f280.svg";